import React, { useEffect } from 'react';
import { useDashboardStore } from './Store_Home';
import { useDateSelection } from './hooks/useDateSelection';
import { DashboardHeader } from './components/DashboardHeader';
import { getSummaryData } from './Utils_Home';
import ChartsSectionC from './components/C/ChartsSection_C';
import ProductionDetailSectionC from './components/C/ProductionDetailSection_C';
import NoticeSectionC from './components/C/NoticeSection_C';
import DateRangePickerModal from './components/DateRangePickerModal';
import { DashboardLoading } from './components/DashboardLoading';

const CtypePage: React.FC = () => {
  const {
    isLoading, hasLoadedOnce, dataSource, error,
    startDate, endDate,
    mainTopData,
    monthlyProductionData, itemGroupData,
    batchDefectData, kpiHistoryData,
    productionDetailData,
    noticeListData, selectedNoticeData,
    fetchDashboardData, updateDateRangeAndFetch, fetchNoticeOne,
  } = useDashboardStore();

  const {
    showDatePicker, handleDateRangeChange, handleDateConfirm,
    handleDateCancel, handleQuickDateSelect, openDatePicker,
  } = useDateSelection({
    onDateRangeUpdate: (from, to) =>
      updateDateRangeAndFetch(from, to, undefined, { includeCTypeData: true }),
  });

  useEffect(() => {
    fetchDashboardData(undefined, { includeCTypeData: true });
  }, [fetchDashboardData]);

  useEffect(() => {
    const firstNotice = noticeListData[0];
    if (firstNotice) {
      fetchNoticeOne(firstNotice.noticeNo);
    }
  }, [noticeListData, fetchNoticeOne]);

  const summaryData = getSummaryData(
    mainTopData, monthlyProductionData,
    itemGroupData, batchDefectData, kpiHistoryData
  );

  return (
    <div className="relative w-full h-full flex flex-col p-4 gap-4">
      <DashboardLoading isLoading={isLoading} hasLoadedOnce={hasLoadedOnce} />
      <DashboardHeader
        isLoading={isLoading}
        dataSource={dataSource}
        error={error}
        startDate={startDate}
        endDate={endDate}
        onQuickDateSelect={handleQuickDateSelect}
        onOpenDatePicker={openDatePicker}
        onRefresh={() => fetchDashboardData(undefined, { includeCTypeData: true })}
      />

      <div className="grid grid-cols-2 gap-4 flex-1 min-h-0">
        <div className="flex flex-col gap-4 min-h-0">
          <ChartsSectionC
            monthlyProductionData={monthlyProductionData}
            batchDefectData={batchDefectData}
          />
          <ProductionDetailSectionC productionDetailData={productionDetailData} />
        </div>
        <NoticeSectionC
          noticeListData={noticeListData}
          selectedNoticeData={selectedNoticeData}
          onNoticeRowClick={(notice) => fetchNoticeOne(notice.noticeNo)}
        />
      </div>

      <div className="text-sm text-gray-500 text-center">
        마지막 업데이트: {summaryData.lastUpdateTime}
      </div>

      <DateRangePickerModal
        visible={showDatePicker}
        title="📅 조회 기간 선택"
        from={startDate}
        to={endDate}
        onChange={handleDateRangeChange}
        onCancel={handleDateCancel}
        onConfirm={handleDateConfirm}
      />
    </div>
  );
};

export default CtypePage;
